import React from 'react';

const DEFAULT_COLORS = ['#1976d2', '#e94560', '#4caf50', '#ff9800', '#9c27b0', '#00bcd4', '#795548', '#607d8b'];

function SeriesColorPicker({ seriesNames, seriesColors, onChange }) {
  if (!seriesNames || seriesNames.length === 0) return null;

  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.5rem',
      alignItems: 'center',
      padding: '0.5rem 0',
    }}>
      <span style={{ fontSize: '0.8rem', color: '#6b7280', marginRight: '0.25rem' }}>Series colors:</span>
      {seriesNames.map((name, idx) => (
        <label
          key={name}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.25rem',
            fontSize: '0.78rem',
            color: '#374151',
          }}
        >
          <input
            type="color"
            value={seriesColors?.[name] || DEFAULT_COLORS[idx % DEFAULT_COLORS.length]}
            onChange={e => onChange({ ...seriesColors, [name]: e.target.value })}
            style={{ width: 22, height: 22, padding: 0, border: '1px solid #d1d5db', borderRadius: 3, cursor: 'pointer' }}
          />
          {name}
        </label>
      ))}
    </div>
  );
}

export default SeriesColorPicker;
